import React from 'react'
import CaseStudyTab from './../../components/CaseStudyTab';
import Navbar from './../../components/Navbar';
import Footer from './../../components/Footer';

import document_security from "../../assets/images/contents/case-study-document-security.png"
import { useTranslation } from 'react-i18next';
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import filter_color from "../../assets/images/design/colorFilter.svg"
import { StyledLink } from '../../components/StyledComponents';

const CaseStudyDocumentSecurity = () => {
  const { t } = useTranslation()

  return (
    <div className='case-study-document-security bg-primary'>
      <div className='color-filter-left' style={{ left: "10%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "25%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid insurance-header pb-100'>
        <div className='container'>
          <div className='col-sm-12 pt-150'>
            <div className='font-weight-bold text-center font-64 insurance-header-title'>{t('case-study.document-security')}</div>
            <div className='col-sm-10 col-sm-offset-1'>
              <div className='underline-orange'></div>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-md-100 pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.case-studies')} currentPage={t('bread-crumbs.document-security')} linkToPrevPage="/case-study" />
          </div>
        </div>
      </div>
      <CaseStudyTab documentSecurityActive={true} />
      <div className='case-study-document-security-content container'>
        <div className='row'>
          <div className="col-lg-4">

            <div className='case-study-document-security-card'>
              <StyledLink href="/case-study/karibia">
                <div className='case-study-document-security-card_image'>
                  <img src={document_security} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip'>
                {t('case-study.document-security')}
              </div>
              <StyledLink href="/case-study/karibia">
                <p className='text-white font-weight-semi-bold font-20'>{t('case-study.card-title-2')}</p>
              </StyledLink>
            </div>

          </div>

        </div>


      </div>
      {/* <div className='container'>
        <IndustriesImageContainer />
      </div> */}
      <Footer />
    </div>
  )
}

export default CaseStudyDocumentSecurity